module.exports = __webpack_public_path__ + "static/img/特斯拉Model Y.444e2545.png";